<template>
  <div class="live-label">
    <v-icon size="8" class="live-label-icon">
      krypt-Ellipse-1
    </v-icon>
    <span class="live-label-text">
          LIVE

    </span>
  </div>
</template>

<script>


export default {
  name: 'krypt-live-label',

};
</script>

<style scoped>
  .live-label {
    background: #38BC6D;
    border-radius: 11px;
    font-size: 10px;
    font-weight: 700;
    /*max-width: 40px*/
    display: flex;
    width: fit-content;

  }
  .live-label:before {
    content: '\A';

  }
  .live-label > .live-label-icon {
      padding: 4px 0px 4px 4px;
    opacity: 0.7;
  }
  .live-label > .live-label-text{
    padding-top: 1px;
    padding-bottom: 1px;
    padding-left: 2px;
    padding-right: 4px;
    color: #FFFFFF;
  }
</style>
